export default "https://cdn-static.gokick.com/assets/45a1ec4753cb63ac9804059da02cc099817f84d7/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";